"use client";

import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useJobStore } from "../../store/jobStore";
import JobCard from "../molecules/JobCard";
import Button from "../atoms/Button";
import SectionBox from "../layout/SectionBox";

export default function JobListingGrid() {
  const location = useLocation();
  const lang = location.pathname.startsWith("/id") ? "id" : "en";

  const {
    jobs,
    fetchJobs,
    filters,
    resetFilters,
    page,
    hasMore,
    loading,
  } = useJobStore();

    useEffect(() => {
    
    resetFilters();
  }, []);

  /* =========================
     INITIAL LOAD + FILTER CHANGE
  ========================== */
  useEffect(() => {
    useJobStore.setState({
      page: 1,
      jobs: [],
    });

    fetchJobs(lang, false);
  }, [lang, filters]);

  /* =========================
     LOAD MORE
  ========================== */
  const handleLoadMore = async () => {
    await fetchJobs(lang, true);
  };


  return (
    <section className="w-full pt-6 relative">
      <div className="container-section mx-auto px-6">
        <SectionBox classNameSub="!mb-0">

          {/* Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {jobs.length > 0 ? (
              jobs.map((job) => (
                <JobCard
                  key={job.id}
                  id={job.id}
                  title={job.title}
                  description={job.description}
                  education={job.education}
                  yearExperience={job.yearExperience}
                  priceRange={job.priceRange}
                  company={job.company}
                  company_logo={job.company_logo}
                  location={job.location}
                  variant="square"
                />
              ))
            ) : !loading ? (
              <div className="col-span-full flex flex-col items-center justify-center py-16 text-center">
                <p className="text-gray-500 text-lg font-medium">
                  No data found
                </p>
                <p className="text-sm text-gray-400 mt-1">
                  Try adjusting your search or filter
                </p>
              </div>
            ) : null}
          </div>

          {/* Load More */}
            <div className="flex justify-center mt-10">
              {hasMore ? (
                <Button
                  onClick={handleLoadMore}
                  bgClass="bg-[#123b7c]"
                  textClass="text-white"
                  className="px-8 py-3 rounded-full font-semibold"
                  disabled={loading}
                >
                  {loading ? "Loading..." : "Load More"}
                </Button>
              ) : (
                <p className="text-center text-sm text-primary py-4">
                  No more jobs available
                </p>
              )}
            </div>

        </SectionBox>
      </div>
    </section>
  );
}
